<template>
  <b-container class="py-5">
    <m-single-contents-wrapper :content-link="contentLink">
      <b-row slot-scope="{ content }">
        <b-col lg="3" class="category-custom-z-index">
          <m-categories-panel-301 :flat-categories-shape="flatCategoriesShape"
                                  class="sticky-top category-custom-z-index"/>
        </b-col>
        <b-col lg="9">
          <div class="container box">
            <b-row>

              <m-a :href="{name:'Home'}" class="text-decoration-none">
                <span class="span-color">خانه</span>
                <b-icon icon="chevron-left" class="icon-color"/>
              </m-a>

              <m-a v-if="$route.name=='SinglePost'" :href="{name:'Posts'}" class="text-decoration-none">
                <span class="span-color">وبلاگ</span>
                <b-icon icon="chevron-left" class="icon-color"/>
              </m-a>

              <m-a v-if="$route.name=='SinglePage'" :href="{name:'Pages'}" class="text-decoration-none">
                <span class="span-color">برگه ها</span>
                <b-icon icon="chevron-left" class="icon-color"/>
              </m-a>

              <a href="#" class="text-decoration-none">
                <span class="span-color text-dark">{{ content.title }}</span>
              </a>

            </b-row>

            <hr class="mt-4 mb-5"/>

            <b-row>
              <b-col cols="12">
                <h5 class="text-dark title">
                  {{ content.title }}
                </h5>
              </b-col>

              <b-col lg="2" md="6" sm="6" class="text col-color mt-4">
                {{ content.author.name }}
              </b-col>

              <b-col lg="6" md="6" sm="6" class="text col-color mt-4">
                <b-icon icon="calendar3"/>
                {{ dateFormat(content.created_at)[1] }}
                |
                {{ dateFormat(content.created_at)[0] }}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" class="mt-3">
                <img :src="content.thumbnail" :alt="content.title" class="content-image"/>
              </b-col>

              <b-col lg="12" sm="12" md="12" class="mt-3 text-secondary text">
                <div v-html="processContent(content.body)"></div>
              </b-col>
            </b-row>

            <hr/>

            <b-row class="mt-5 mb-5">
              <b-col lg="12">
                <span class="font-weight-bold text-secondary">برچسب ها :</span>

                <span class="badge badge-info key_word_category_button rounded-pill h5 px-2 mx-1 cursor_pointer "
                      v-for="item in content.keywords" :key="item.id">{{ item.keyword }}</span>
              </b-col>
              <b-col lg="12">
                <span class="font-weight-bold text-secondary">دسته بندی ها:</span>


                <m-a v-for="category in content.category" :key="content.id"
                     :href="{name:'Posts',query:{category:category.slug}}">
              <span class="badge badge-info key_word_category_button rounded-pill h5 px-2 mx-1 cursor_pointer ">
                {{ category.name }}
              </span>
                </m-a>


              </b-col>
            </b-row>

            <div class="d-none">
              <hr/>

              <b-row>
                <b-col lg="12" class="mt-4 text-center">
                  <a href="#">
                    <b-button class="bt-col">دیدگاه شما</b-button>
                  </a>
                </b-col>

                <div>
            <span class="font-weight-bold text-secondary mt-2 ml-3"
            >یک دیدگاه</span
            >
                </div>

                <div class="border-col"></div>
              </b-row>

              <b-row class="mt-5">
                <b-col lg="3" md="12" sm="12" class="margin-col">
            <span class="font-weight-bold text-secondary">
              <b-icon
                  icon="person-square"
                  class="ml-3 icon-col"
              />SohylKia</span
            >
                </b-col>

                <b-col lg="5" md="12" sm="12" class="text-secondary">
                  <b-icon icon="stopwatch"/>
                  <span>23خرداد 1401</span>
                  <b-icon icon="cursor-text"/>
                  <span>09:58</span>
                </b-col>

                <b-col lg="4" class="icon text-secondary">
                  <b-icon icon="star"/>
                  <span class="ml-1">1</span>
                  <b-icon icon="cursor-text" class="ml-3 mr-3"/>
                  <b-icon icon="arrow90deg-left"/>
                </b-col>

                <b-col lg="12" class="mt-5 text-secondary">
                  <p>
                    چقدر غیر منتظره بود معرفی فورزا موتور اسپر جدید بی صبرانه منتظرشیم
                  </p>
                </b-col>
              </b-row>
            </div>
          </div>
          <b-col class="my-3">
            <m-single-post-related-300 :content="content"/>
          </b-col>
        </b-col>
      </b-row>
    </m-single-contents-wrapper>
  </b-container>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter.js";

export default {
  name: "SinglePost501",
  props: {
    contentLink: {
      default: null,
    },
    flatCategoriesShape: {
      default: false,
    }
  },
  methods: {
    dateFormat(value) {
      return dateConverter(value, "/", true).split(" ");
    },

  },
};


</script>

<style scoped>
.box {
  border-radius: 5px;
  padding: 30px 50px;
  background: white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.span-color {
  color: #c3c3c3;
  font-size: 12px;
}

.icon-color {
  color: #c3c3c3;
  font-size: small;
}

.col-color {
  color: #c3c3c3;
}

@media only screen and (max-width: 1440px) {
  .title {
    font-size: 16px !important;
  }

  .text {
    font-size: 16px;
  }
}

@media only screen and (max-width: 320px) {
  .title {
    font-size: 12px !important;
  }

  .text {
    font-size: 8px;
  }
}

.icon-col {
  font-size: 20px !important;
}

.icon {
  font-size: 20px;
}

.border-col {
  flex-grow: 1;
  border-top: 1px solid #dedede;
  margin-top: 16px !important;
}

.bt-col {
  color: #c3c3c3;
  background-color: var(--light-blue);
  border-radius: 20px !important;
  border: none;
}

.bt-span {
  color: #c3c3c3;
  background-color: var(--light-blue);
  padding: 5px;
  border-radius: 20px !important;
  font-size: 10px;
  border: none;
  display: inline !important;
}

@media only screen and (max-width: 1440px) {
  .icon {
    text-align: left;
  }

  .margin-col {
    margin-bottom: 0;
  }
}

@media only screen and (max-width: 1000px) {
  .icon {
    text-align: right;
    margin-top: 15px;
  }

  .margin-col {
    margin-bottom: 15px !important;
  }
}

.cursor_pointer {
  cursor: pointer;
}

.content-image {
  max-height: 600px;
  object-fit: cover;
  width: 100%;
}

.key_word_category_button {
  background: #f2f2f2;
  color: #a2a2a2;
}

.category-custom-z-index {
  z-index: 0 !important;
}

</style>
